//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../../EventBus/EventBus'
import ReportCheckListWorkType from './ReportCheckListWorkType.vue'
import { LABEL_MARKS } from '../../Request/RequestWorkTypes.js'
import { technologicalOperationHasResult } from './ReportCheckListTechnologicalOperationHasResult.js'

export default {
  components: {
    ReportCheckListWorkType: ReportCheckListWorkType
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    workPackage: {
      type: Object,
      default () {
        return {}
      }
    },
    allWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    allWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    setup: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    showPreviousDepartures: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      opened: false,
      openedWorkPackage: false,
      workPackageMark: LABEL_MARKS.workPackage
    }
  },
  computed: {
    workPackageHeaderAdditionalStyle: function () {
      if (this.worksDoneCount === this.workTypesCount && !this.setup) {
        return 'background-color: rgba(197,247,203);'
      } else if (this.worksDoneCount > 0 && !this.setup) {
        return 'background-color: rgba(245,247,197);'
      } else {
        return ''
      }
    },
    workTypesNotHided: function () {
      return this.workPackage.workTypes.filter(workType => !workType.hideWork)
    },
    worksDoneCount: function () {
      return this.workTypesNotHided.filter(workType => workType.includedInCurrentReport && workType.done).length
    },
    workTypesInCurrentReportCount: function () {
      return this.workTypesNotHided.filter(workType => workType.includedInCurrentReport).length
    },
    workTypesCount: function () {
      return this.workTypesNotHided.length
    }
  },
  created: function () {
    if (!sessionStorage.getItem(this.workPackage.id.toString() + this.report.id + '_opened')) {
      if (this.setup) {
        this.opened = true
      }
    } else {
      this.opened = sessionStorage.getItem(this.workPackage.id.toString() + this.report.id + '_opened') === 'true'
    }
    this.openedWorkPackage = sessionStorage.getItem(this.workPackage.id.toString() + this.report.id + '_openedWorkPackage') === 'true'

    if (this.workPackage.workTypes.length === 1) {
      this.opened = true
      this.openedWorkPackage = true
    }

    this.onChangeRemarkTechnologicalOperationsAndOpenWorkPackage()
    EventBus.$on('task-closed', this.clearSessionStorage)
  },
  beforeDestroy: function () {
    EventBus.$off('task-closed', this.clearSessionStorage)
  },
  methods: {
    getFullWorkTypesCount: function (workPackage) {
      const rawWorkPackage = this.allWorkPackages.find(wP => wP.id === workPackage.id)
      return rawWorkPackage.workTypes.length
    },
    clearSessionStorage: function () {
      sessionStorage.removeItem(this.workPackage.id.toString() + this.report.id + '_opened', this.opened)
      sessionStorage.removeItem(this.workPackage.id.toString() + this.report.id + '_openedWorkPackage', this.openedWorkPackage)
    },
    openWorkPackageFn: function (open = null) {
      if (open != null) {
        this.opened = !open
        this.openedWorkPackage = !open
        this.$nextTick(() => {
          this.opened = !!open
          this.openedWorkPackage = !!open
        })
      } else {
        if (this.openedWorkPackage) {
          this.opened = false
          this.openedWorkPackage = false
        } else {
          this.opened = true
          this.openedWorkPackage = true
        }
      }

      sessionStorage.setItem(this.workPackage.id.toString() + this.report.id + '_opened', this.opened)
      sessionStorage.setItem(this.workPackage.id.toString() + this.report.id + '_openedWorkPackage', this.openedWorkPackage)
    },
    onWorkPackageHeader: function () {
      this.opened = !this.opened
      sessionStorage.setItem(this.workPackage.id.toString() + this.report.id + '_opened', this.opened)
    },
    onChangeRemarkTechnologicalOperationsAndOpenWorkPackage: function () {
      for (let i = 0; i < this.workPackage.workTypes.length; i++) {
        const workType = this.workPackage.workTypes[i]
        const technologicalOperations = workType.technologicalOperations
        for (let j = 0; j < technologicalOperations.length; j++) {
          const technologicalOperation = technologicalOperations[j]
          if (this.roleExecutor && (
            technologicalOperation.remark ||
            !technologicalOperation.done && technologicalOperation.required ||
            !technologicalOperationHasResult(technologicalOperation, this.report, workType) && technologicalOperation.resultsRequired
          )) {
            this.opened = true
          }
        }
      }

      this.$emit('remark-changed')
    }
  }
}

